import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PolicyTooltipService } from '@services/my-insurance/policy-tooltip.service';
import { Constants } from '@models/constants';
import { InfoTooltipComponent } from '../../../../../common/info-tooltip/info-tooltip.component';
import { CustomDateFormatPipe } from '@helpers/_pipes/custom-date-format.pipe';

@Component({
  standalone: true,
  selector: 'app-policy-card-min-amount-due',
  templateUrl: './policy-card-min-amount-due.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    InfoTooltipComponent,CustomDateFormatPipe,
  ]
})
export class PolicyCardMinAmountDueComponent implements OnInit {
  @Input() policy: any;
  @ViewChild('minAmtTooltip') minAmtTooltip?: InfoTooltipComponent;

  isAcmic: boolean;
  tooltipContent: string;
  hasOutstandingBalance: boolean;

  constructor(
    private acmicService: AcmicService,
    private policyTooltipService: PolicyTooltipService,
  ) {}

  get isMobile(): boolean {
    return this.policyTooltipService.isMobile;
  }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.tooltipContent = this.policyTooltipService.getMinAmountDueTooltip();
    this.hasOutstandingBalance = this.hasOutstandingBilling()
  }

  toggleTooltip(event: Event, tooltip: InfoTooltipComponent) {
    event.stopPropagation();
    tooltip.toggle();
  }

  expandBalances(): void {
    const policyNumber = this.policy?.policynumber?.policyNumber;
    if (!policyNumber) { return; }

    const displayEl = document.getElementById(`display-${policyNumber}`);

    if (displayEl) {
      if (!displayEl.classList.contains(Constants.HIDE_AMOUNT_CLASS)) {
        displayEl.classList.add(Constants.HIDE_AMOUNT_CLASS);
      } else {
        displayEl.classList.remove(Constants.HIDE_AMOUNT_CLASS);
      }
    }
  }

  private hasOutstandingBilling(): boolean {
    const billing = this.policy?.billingDetails?.[0];
    if (!billing) return false;
    return billing.outstandingbalance != 0 || 
          billing.amountStillDue > 0 || 
          billing.priorYearBalance > 0;
  }
}
